import { render, staticRenderFns } from "./NosePunching1.vue?vue&type=template&id=6f7a3aa0&scoped=true&"
import script from "./NosePunching1.vue?vue&type=script&lang=js&"
export * from "./NosePunching1.vue?vue&type=script&lang=js&"
import style0 from "./NosePunching1.vue?vue&type=style&index=0&id=6f7a3aa0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f7a3aa0",
  null
  
)

export default component.exports